module.exports = __webpack_public_path__ + "static/media/3DPPA25.cee6574b.jpg";